import { render, staticRenderFns } from "./ReminderPanel.vue?vue&type=template&id=70126018&"
import script from "./ReminderPanel.vue?vue&type=script&lang=js&"
export * from "./ReminderPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReminderPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports